import { removeHashParams } from 'utils/helper-functions/remove-hash-params';

const hasRecoverySettings = (location) =>
  !!location &&
  (location.recoverySettingsObject !== undefined ||
    (typeof location.hash === 'string' && location.hash.includes('recoverySettings=')));

const saveLocation = (state, action) => {
  if (state === undefined) {
    return false;
  }
  switch (action.type) {
    case 'SAVE-LOCATION':
      return action.payload;
    // A tab switch drops the previous tab's decline recovery settings, so
    // neither the new tab's requests nor a later reload pick them up.
    case 'RESET_TAB_STATE': {
      const { location } = state;
      if (!hasRecoverySettings(location)) return location;

      const { recoverySettingsObject, recoverySettings, ...rest } = location;
      return {
        ...rest,
        hash: '',
        ...(typeof location.href === 'string' && { href: removeHashParams(location.href) }),
      };
    }
    default:
      return state.location;
  }
};

export { saveLocation };
